import { styled } from '@mui/material/styles';
import { Select } from '@mui/material';

export const StyledWorkspaceSelect = styled(Select)(({ theme }) => ({
  marginRight: theme.spacing(1),
  '& .MuiSelect-icon': {
    color: theme.palette.black.main,
  }
})); 